<template>
  <div>
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="客户导入模板" prop="custom_module_url">
        <el-input :value="form.custom_module_url" placeholder="模板下载地址" style="width: 600px">
          <template #append>
            <upload-file v-model="form.custom_module_url">
              <el-button type="primary">上传</el-button>
            </upload-file>
          </template>
        </el-input>
      </el-form-item>

      <el-form-item label="余卡导入模板" prop="custom_card_module_url">
        <el-input :value="form.custom_card_module_url" placeholder="模板下载地址" style="width: 600px">
          <template #append>
            <upload-file v-model="form.custom_card_module_url">
              <el-button type="primary">上传</el-button>
            </upload-file>
          </template>
        </el-input>
      </el-form-item>

      <el-form-item label="项目导入模板" prop="project_module_url">
        <el-input :value="form.project_module_url" placeholder="模板下载地址" style="width: 600px">
          <template #append>
            <upload-file v-model="form.project_module_url">
              <el-button type="primary">上传</el-button>
            </upload-file>
          </template>
        </el-input>
      </el-form-item>

      <el-form-item label="产品导入模板" prop="product_module_url">
        <el-input :value="form.product_module_url" placeholder="模板下载地址" style="width: 600px">
          <template #append>
            <upload-file v-model="form.product_module_url">
              <el-button type="primary">上传</el-button>
            </upload-file>
          </template>
        </el-input>
      </el-form-item>

      <el-form-item label="卡项导入模板" prop="card_module_url">
        <el-input :value="form.card_module_url" placeholder="模板下载地址" style="width: 600px">
          <template #append>
            <upload-file v-model="form.card_module_url">
              <el-button type="primary">上传</el-button>
            </upload-file>
          </template>
        </el-input>
      </el-form-item>

      <el-form-item label="用户协议" prop="user_agreement">
        <v-editor v-model="form.user_agreement" placeholder="用户协议"></v-editor>
      </el-form-item>

      <el-form-item label="隐私协议" prop="privacy">
        <v-editor v-model="form.privacy" placeholder="隐私协议"></v-editor>
      </el-form-item>

      <el-form-item label="软件服务协议" prop="software_service">
        <v-editor v-model="form.software_service" placeholder="软件服务协议"></v-editor>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="commit">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import uploadFile from '../../components/Upload/upload-file.vue'
export default {
  components: { uploadFile },
  name: 'settings',
  data() {
    return {
      form: {},
      rules: {
        user_agreement: [{ required: true, message: '必填！', trigger: 'change' }],
        privacy: [{ required: true, message: '必填！', trigger: 'change' }],
        software_service: [{ required: true, message: '必填！', trigger: 'change' }]
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      const { data } = await this.$api.setting.getting()
      this.form = data
    },
    async commit() {
      const params = { ...this.form }
      await this.$api.setting.putting(params)
      this.$message.success('保存成功！')
      this.load()
    }
  }
}
</script>